import { defineComponent } from 'vue';
import SidebarInfoItem from './SidebarInfoItem.vue';
export default defineComponent({
    name: 'SignupTemplateSidebar',
    components: {
        SidebarInfoItem,
    },
    emits: ['signup'],
    setup(_, { emit }) {
        const signup = () => {
            emit('signup');
        };
        return { signup };
    },
});
